"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var image_1 = __importDefault(require("next/image"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var classnames_1 = __importDefault(require("classnames"));
var MethodItem = function (_a) {
    var _b;
    var _c = _a.isActive, isActive = _c === void 0 ? false : _c, method = _a.method, onClick = _a.onClick, isDisabled = _a.isDisabled, background = _a.background, label = _a.label, styles = _a.styles, name = _a.name, className = _a.className;
    var getPaymentImagePath = (0, react_1.useCallback)(function (method) {
        var methodId = method.childMethodId || method.name;
        return "/img/payments/".concat(methodId, ".svg");
    }, []);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_module_scss_1.default.container, (_b = {},
            _b[styles_module_scss_1.default.active] = isActive,
            _b), className), style: { background: background }, onClick: function () { return (!isDisabled ? onClick() : null); } },
        (label || (styles === null || styles === void 0 ? void 0 : styles.label)) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.label }, label || (styles === null || styles === void 0 ? void 0 : styles.label))),
        react_1.default.createElement(image_1.default, { src: getPaymentImagePath(method), width: 115, height: 36, alt: name, className: styles_module_scss_1.default.image })));
};
exports.default = MethodItem;
